import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { FundDetailsService } from '../../services/fund-details/fund-details';
import { OfferingStatus } from '../../enums/fund-status';
import { ROUTE_PATHS } from '../../utils/route-paths.const';
import { FUND_DETAILS_TABS } from '../../constants/tab-names.const';

export const unitValueChangeGuard: CanActivateFn = (
  route
): Observable<boolean> => {
  const fundDetailsService = inject(FundDetailsService);
  const router = inject(Router);
  const fundUuid = route.paramMap.get('fundUuid');

  // Fall back to the fund's main-details tab: the Unit Management tab is hidden
  // for funds without a succeeded investment, so we can't always return there.
  const navigateToFundDetails = (): void => {
    router.navigate(
      [ROUTE_PATHS.FUND_MANAGEMENT, fundUuid, ROUTE_PATHS.DETAILS],
      { queryParams: { tab: FUND_DETAILS_TABS.MAIN_DETAILS } }
    );
  };

  if (!fundUuid) {
    router.navigate([ROUTE_PATHS.ROOT]);
    return of(false);
  }

  const navigation = router.currentNavigation();
  const bypassGuard = navigation?.extras?.state?.['bypassGuard'];
  if (bypassGuard) {
    return of(true);
  }

  return fundDetailsService.getFundDetails(fundUuid).pipe(
    map(fundDetails => {
      if (fundDetails.offering?.state?.value !== OfferingStatus.COMPLETED) {
        navigateToFundDetails();
        return false;
      }
      return true;
    }),
    catchError(() => {
      router.navigate([ROUTE_PATHS.ROOT]);
      return of(false);
    })
  );
};
